import { appData } from '@/mocks/comics';

export default function AppSection() {
  return (
    <section id="app" className="py-10 md:py-14 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-4">
              APP下载
            </h2>
            <h3 className="text-lg md:text-xl text-primary-600 font-heading mb-4">
              {appData.title}
            </h3>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-lg mx-auto lg:mx-0">
              {appData.desc}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3 mb-6">
              {appData.features.map((feat) => (
                <span
                  key={feat}
                  className="inline-flex items-center gap-1.5 text-xs font-medium text-foreground-700 bg-background-100 border border-background-200 px-3 py-1.5 rounded-full"
                >
                  <i className="ri-check-line text-primary-500 text-sm"></i>
                  {feat}
                </span>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#app"
                className="inline-flex items-center gap-2 px-8 py-3 bg-foreground-950 text-white rounded-full text-sm font-medium hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-apple-fill text-lg"></i>
                App Store
              </a>
              <a
                href="#app"
                className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-android-fill text-lg"></i>
                Android 下载
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[240px] md:w-[280px] aspect-[1/2] rounded-2xl overflow-hidden border-4 border-background-200">
              <img
                src={appData.image}
                alt="YY漫画APP下载"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}